import { Component } from '@theme/component';
import { trackEvent } from '@theme/utilities';
import { CartAddEvent } from '@theme/events';

export class TailwindProductCard extends Component {
    constructor() {
        super();
        this.uniqueId = this.getAttribute("data-unique-id") || this.dataset.uniqueId;  
    }

    connectedCallback() {
        this.form = this.querySelector('form');
        if (this.form) {
            this.form.addEventListener('submit', this._onFormSubmit.bind(this));
        }
    }

    _onFormSubmit(e) {
        e.preventDefault();
        
        const form = this.form;
        const button = form.querySelector('button[type="submit"]');
        const text = button?.querySelector('.btn-text');
        const spinner = button?.querySelector('.btn-spinner');

        if (!button || button.disabled) return;

        button.disabled = true;
        if (text) text.style.visibility = 'hidden';
        spinner?.classList.remove('hidden');

        const cartItemsComponent = document.querySelector('cart-items-component');
        const sectionId = cartItemsComponent ? cartItemsComponent.getAttribute('data-section-id') : 'cart-drawer';

        const formData = new FormData(form);
        formData.append('sections', sectionId); 

        fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            body: formData
        })
        .then(response => {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
        })
        .then(data => {

            if (data.sections && data.sections[sectionId]) {
                const parser = new DOMParser();
                const responseDoc = parser.parseFromString(data.sections[sectionId], 'text/html');
                const newItemsHTML = responseDoc.querySelector('cart-items-component');
                
                if (newItemsHTML && cartItemsComponent) {
                    cartItemsComponent.innerHTML = newItemsHTML.innerHTML;
                    const dialog = document.querySelector('.cart-drawer__dialog');
                    if (dialog) dialog.classList.remove('cart-drawer--empty');
                }
            }

  
            document.dispatchEvent(new CustomEvent('cart:updated', { 
                detail: { cart: data } 
            }));

   
            trackEvent('ajax_cart_add', {
                product_id: data.product_id,
                variant_id: data.id,
                price: data.price
            });


            button.focus({ preventScroll: true });

            
            const cartAddEvent = new CustomEvent(CartAddEvent.eventName, {
                bubbles: true,
                cancelable: true,
                detail: {
                    cart: data,
                    source: button
                }
            });
            
            document.dispatchEvent(cartAddEvent);

            const drawerComponent = document.querySelector('cart-drawer-component');
            if (drawerComponent && !drawerComponent.hasAttribute('auto-open')) {
                if (typeof drawerComponent.open === 'function') {
                    drawerComponent.open();
                } else if (typeof drawerComponent.showDialog === 'function') {
                    drawerComponent.showDialog();
                }
            }
        })
        .catch(error => {
            console.error('Cart Refresh Error:', error);
            window.location.reload(); 
        })
        .finally(() => {
            if (button) button.disabled = false;
            if (text) text.style.visibility = 'visible';
            spinner?.classList.add('hidden');
        });
    }
}

if (!customElements.get('tailwind-product-card')) {
    customElements.define('tailwind-product-card', TailwindProductCard);
}